import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

import { KeyFeaturesContextProvider } from "@/components/Product/Feature/KeyFeatures/context/keyFeatures.context";
import { KeyFeature } from "@/components/Product/Feature/KeyFeatures/keyFeatures.types";

type Props = {
    features: Array<KeyFeature>;
    amountOfFeatures?: number;
    className?: string;
    children: ReactNode;
};

export const Base = ({
    features,
    amountOfFeatures = 4,
    className,
    children
}: Props) => {
    const keyFeatures = features
        .filter((f) => !!f.coreFeature)
        .slice(0, amountOfFeatures);

    if (keyFeatures.length === 0) return null;

    return (
        <KeyFeaturesContextProvider keyFeatures={keyFeatures}>
            <div className={cn(className)}>{children}</div>
        </KeyFeaturesContextProvider>
    );
};
